import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-bootstrap/Modal';
import SoftButton from 'components/SoftButton';
import SoftInput from 'components/SoftInput';
import SoftTypography from 'components/SoftTypography';
import Grid from '@mui/material/Grid';
import Swal from 'sweetalert2';
import axios from 'axios';
import { useParams } from 'react-router-dom';

import DocumentTypeSelector from 'components/DocumentTypeSelector';

const ModalEditDocument = ({ show, handleClose, initialData, onRefresh }) => {
  // Extraemos el id de orden cabecera desde la URL
  const { numeroOrdenCabecera } = useParams();

  // Incluimos id_cabecera en el estado del formulario
  const [formData, setFormData] = useState({
    nombreDocumento: '',
    nota: '',
    tipo: '',
    id_cabecera: '', // nuevo campo
  });

  useEffect(() => {
    if (initialData) {
      setFormData({
        nombreDocumento: initialData.nombre || '',
        nota: initialData.nota || '',
        tipo: initialData.tipo || '',
        id_cabecera: numeroOrdenCabecera, // usamos el valor de la URL
      });
    } else {
      setFormData({
        nombreDocumento: '',
        nota: '',
        tipo: '',
        id_cabecera: numeroOrdenCabecera,
      });
    }
  }, [initialData, show, numeroOrdenCabecera]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  // Usamos DocumentTypeSelector para actualizar 'tipo'
  const handleSave = () => {
    if (!formData.nombreDocumento || !formData.nota || !formData.tipo) {
      Swal.fire({
        icon: 'error',
        title: 'Campos incompletos',
        text: 'Por favor complete todos los campos.'
      });
      return;
    }

    axios
      .patch(`${process.env.REACT_APP_SERVER_URL}/api/orders/documents/${initialData.id_documentos}/`, formData)
      .then((response) => {
        Swal.fire({
          icon: 'success',
          title: 'Actualizado',
          text: 'El documento ha sido actualizado correctamente!'
        });
        handleClose();
        if (onRefresh) onRefresh();
      })
      .catch((error) => {
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Error al actualizar el documento. Inténtelo nuevamente.'
        });
        console.error("Error updating document:", error);
      });
  };

  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>Editar Documento</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <SoftTypography variant="caption" fontWeight="bold" color="text">
              Nombre del documento
            </SoftTypography>
            <SoftInput
              type="text"
              name="nombreDocumento"
              placeholder="Ingrese el nombre del documento"
              value={formData.nombreDocumento}
              onChange={handleInputChange}
            />
          </Grid>
          <Grid item xs={12}>
            <SoftTypography variant="caption" fontWeight="bold" color="text">
              Nota del documento
            </SoftTypography>
            <SoftInput
              type="text"
              name="nota"
              placeholder="Ingrese una nota"
              value={formData.nota}
              onChange={handleInputChange}
            />
          </Grid>
          <Grid item xs={12}>
            <DocumentTypeSelector
              selectedDocumentType={formData.tipo}
              setSelectedDocumentType={(value) =>
                setFormData((prev) => ({ ...prev, tipo: value }))
              }
            />
          </Grid>
        </Grid>
      </Modal.Body>
      <Modal.Footer>
        <SoftButton variant="gradient" color="success" onClick={handleSave}>
          Guardar
        </SoftButton>
        <SoftButton variant="gradient" color="error" onClick={handleClose}>
          Cancelar
        </SoftButton>
      </Modal.Footer>
    </Modal>
  );
};

ModalEditDocument.propTypes = {
  show: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  initialData: PropTypes.object,
  onRefresh: PropTypes.func,
};

export default ModalEditDocument;
